import type { Workspace } from "@/features/workspaces/types/workspaceWidget.ts";

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface CurrentWorkspaceState {
  currentWorkspace: Workspace | null;
  userId: string | null;
  setCurrentWorkspace: (workspace: Workspace | null) => void;
  setUserId: (userId: string | null) => void;
  resetWorkspace: () => void;
  updateWorkspaceLogo: (logoUrl: string) => void;
  updateWorkspaceName: (name: string) => void;
}

export const useCurrentWorkspaceStore = create<CurrentWorkspaceState>()(
  persist(
    (set, get) => ({
      currentWorkspace: null,
      userId: null,
      setCurrentWorkspace: (workspace) => set({ currentWorkspace: workspace }),
      setUserId: (userId) => set({ userId }),
      resetWorkspace: () => set({ currentWorkspace: null, userId: null }),
      updateWorkspaceLogo: (logoUrl: string) => {
        const { currentWorkspace } = get();

        if (currentWorkspace) {
          set({
            currentWorkspace: {
              ...currentWorkspace,
              logo: logoUrl,
            },
          });
        }
      },
      updateWorkspaceName: (name: string) => {
        const { currentWorkspace } = get();

        if (currentWorkspace) {
          set({
            currentWorkspace: {
              ...currentWorkspace,
              name: name,
            },
          });
        }
      },
    }),
    {
      name: "current-workspace-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
